import { render, staticRenderFns } from "./CapacitacionesBase.vue?vue&type=template&id=278a5f60&scoped=true&"
import script from "./CapacitacionesBase.vue?vue&type=script&lang=ts&"
export * from "./CapacitacionesBase.vue?vue&type=script&lang=ts&"
import style0 from "./CapacitacionesBase.vue?vue&type=style&index=0&id=278a5f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a5f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('278a5f60', component.options)
    } else {
      api.reload('278a5f60', component.options)
    }
    module.hot.accept("./CapacitacionesBase.vue?vue&type=template&id=278a5f60&scoped=true&", function () {
      api.rerender('278a5f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Capacitaciones/CapacitacionesBase.vue"
export default component.exports